<template>
  <div class="projects u-relative">
    <div class="projects__container">
      <div class="u-pad-x-1of12--sm">
        <h1 class="u-center t-h1 u-blue u-pad-t-lg u-marg-b-md u-pad-b-sm">
          What we do?
        </h1>
        <!-- categories -->
        <div class="u-row u-center u-top">
          <div
            class="projects__cat u-w1of10 u-w3of10--sm u-marg-t-md"
            v-for="(category, index) in categories"
            :key="index"
            @click="onCategory(category)"
            :class="{'is-not-selected': selectedCategory.id && selectedCategory.id !== category.id}"
          >
            <div class="u-row u-center">
              <div class="u-w5of10 u-w7of10--sm u-box-1by1 u-round u-overflow-hidden">
                <app-image :width="400" :height="400" :id="category.image[0].id" :src="category.image[0].url" class="projects__cat__image u-wrapper-panel u-fit-cover" />
              </div>
            </div>
            <h3 class="t-text--xsmall u-marg-t-sm u-pad-x-xs">
              {{ category.title }}
            </h3>
          </div>
        </div>
      </div>
      <div class="u-marg-t-xl u-pad-x-1of12">
        <!-- net/category title -->
        <div class="u-black u-row u-middle u-relative" ref="title">
          <div class="projects__title u-relative u-full-width u-overflow-hidden u-z-base">
            <div
              class="projects__title__item t-h3 u-inline-block u-pad-r-md u-relative"
              :class="{'is-selected': selectedCategory.id === category.id}"
              v-for="(category, index) in categories"
              :key="index"
            >
              <span
                class="projects__title__item__lettre u-bg-grey-light"
                :class="`projects__title__item__lettre--${index}`"
                v-for="(letter, index) in category.title" 
                v-html="letter === ' ' ? '&nbsp;' : letter"
              />
            </div>
            <div class="projects__title__bar" :class="{'is-loading': isLoading}"></div>
          </div>
        </div>
        <!-- projects -->
        <div class="projects__list u-relative u-marg-t-md u-row u-marg-x-0--sm" :class="{'is-loading': isLoading}">
          <project-card
            class="u-w10of10--sm u-pad-x-md u-marg-y-md u-marg-y-sm--sm"
            :class="index % 5 !== 0 ? 'u-w5of10' : 'u-w10of10'"
            v-for="(project, index) in projects"
            v-show="!isLoading"
            :isSmall="index % 5 !== 0"
            :key="index"
            :data="project"
          />
          <transition name="t-fader">
            <div v-if="isLoading" class="projects__list__loader u-wrapper-panel u-row u-center u-middle">
              <svg class="u-relative spin__loader u-w1of8">
                <use xlink:href="#icon-loader"/>
              </svg>
            </div>
          </transition>
        </div>
        <!-- header -->
        <div v-if="!$device.isMobile" class="projects__header u-row u-center u-pad-t-md u-pad-b-sm u-bg-white u-pad-x-md" :class="{'is-visible': isScrolled}">
          <div
            class="projects__cat u-flex u-center u-middle"
            v-for="(category, index) in categories"
            :key="index"
            @click="onCategory(category)"
            :class="{'is-not-selected': selectedCategory.id && selectedCategory.id !== category.id}"
          >
            <div class="projects__cat__icon u-w3of12">
              <div class="u-box-1by1 u-round u-overflow-hidden">
                <app-image :width="400" :height="400" :id="category.image[0].id" :src="category.image[0].url" class="projects__cat__image u-wrapper-panel u-fit-cover" />
              </div>
            </div>
            <h3 class="u-w8of12 u-marg-l-1of12 t-text--xsmall u-left u-pad-r-xs">
              {{ category.title }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'
import AppImage from '@/components/common/AppImage'
import ProjectCard from '@/components/ProjectCard'

export default {
  metaInfo () {
    return {
      link: [
        { rel: 'canonical', href: 'https://brig.ht/projects' }
      ]
    }
  },
  components: {
    AppButton,
    AppImage,
    ProjectCard
  },

  computed: {
    data () {
      return this.$store.getters['data/projects']
    },
    projects () {
      return this.$store.getters['data/projects']
    },
    categories () {
      return this.$store.getters['data/categories']
    }
  },

  data () {
    return {
      selectedCategory: {},
      isScrolled: false,
      isLoading: true
    }
  },

  created () {
    this.limit = Infinity

    if (this.$route.query.category) {
      const category = this.categories.filter(cat => cat.slug === this.$route.query.category)
      if (category.length) {
        this.onCategory(category[0])
      }
    }
    else {
      this.$store.dispatch('data/projects').then(() => {
        this.isLoading = false
      })
    }
  },

  mounted () {
    this.onResize()
  },

  methods: {
    onResize () {
      this.limit = this.$offset.absolute(this.$refs.title).top
    },
    onScroll () {
      this.isScrolled = this.$device.scroll.top > this.limit - this.$device.scroll.top * .3
    },
    onCategory (category) {
      if (category.slug !== this.$route.query.category) {
        this.$router.push({...this.$local('Projects'), query: {category: category.slug}})
      }

      this.isLoading = true

      const timePromise = new Promise(resolve => {
        setTimeout(resolve, 500)
      })

      const loadPromise = new Promise(resolve => {
        if (this.selectedCategory.id === category.id) {
          this.selectedCategory = {}
          this.$store.dispatch('data/projects').then(() => {
            resolve()
          })
        }
        else {
          this.selectedCategory = category
          this.$store.dispatch('data/projects', [this.selectedCategory.id]).then(() => {
            resolve()
          })
        }
      })

      Promise.all([timePromise, loadPromise]).then(() => {
        this.isLoading = false
      })
    }
  } 
}
</script>


<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'
@import '~@/styles/settings/mixins/mq'

.projects
  &__container
    max-width bp-wide
    margin 0 auto

  &__cat
    cursor pointer
    opacity 1
    transition opacity .3s linear

    &__icon
      max-width 100px

    &__image
      transition transform 1s ease-in-out-quad
      transform scale(1, 1) translateZ(0)
    
    &:hover &__image 
      transform scale(1.1, 1.1) translateZ(0)
    
    &.is-not-selected
      opacity .5
  
  &__header
    position fixed
    top 80px
    left 0
    transform translateY(-120px) translateZ(0)
    transition transform .5s ease-in-out-quad
    +mq($from: 'wide')
      padding $spacings.md "calc(50% - %s)" % (bp-wide/2)
    
    &.is-visible
      transform translateY(0) translateZ(0)
    
    .projects__cat
      width 12.5%
      display flex
      flex-direction row
      flex-wrap wrap

  &__title    
    &__item
      position absolute
      top 0
      left 0
      z-index 1
      overflow hidden

      &__lettre
        transform translateY(100%) translateZ(0)
        transition transform .5s ease-in-out-quad
        display: inline-block
        
        for index in (0..30)
          &--{index}
            transition-delay index * .05s

      &.is-selected &__lettre
        transform translateY(0) translateZ(0)

        for index in (0..30)
          &--{index}
            transition-delay 1 + index * .02s

      &:first-child
        position relative

    &__bar
      content ''
      height 2px
      position absolute
      top calc(60%)
      background-color: $colors.black
      width 100%
      transform-origin 0% 50%
      transform scaleX(1) translateZ(0)
      transition transform .35s 1s ease-in-out-quad
      
      &.is-loading
        transform scaleX(0) translateZ(0)
        transition transform .35s ease-in-out-quad

  &__list
    &.is-loading
      min-height calc( 100vh - 100px)
    
    &__loader
      position absolute
      &:before
        content ''
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        opacity .5
        background-color: $colors.grey-light
        
</style>